import { verifyExistsEffect } from './plan-effects'
import * as ActionUtility from '@utilities/action-utility'

const REQUEST_VERIFY_EXISTS_PLAN = 'Aberto.Onboarding.REQUEST_VERIFY_EXISTS_PLAN'
const REQUEST_VERIFY_EXISTS_PLAN_FINISHED = 'Aberto.Onboarding.REQUEST_VERIFY_EXISTS_PLAN_FINISHED'

const verifyExists = planId => {
  return async dispatch => {
    await ActionUtility.createThunkEffect(dispatch, REQUEST_VERIFY_EXISTS_PLAN, verifyExistsEffect, { planId })
  }
}

export { verifyExists, REQUEST_VERIFY_EXISTS_PLAN, REQUEST_VERIFY_EXISTS_PLAN_FINISHED }
